import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { IBaseStore } from '@/store/types'
import Api from '@/api'
import { ITodoLineItem, ITodoPaymentData } from '@zunta/configurations'

export interface ITodoState {
    todos: ITodoLineItem[]
    paymentsData: ITodoPaymentData
}

export interface ITodoStore extends IBaseStore {
    state: ITodoState
}

@Module({
    name: 'todo',
    namespaced: true
})
export class TodoModule extends VuexModule {
    todos: Array<ITodoLineItem & { showTooltip?: boolean }> = []
    paymentsData: ITodoPaymentData | null = null

    @Mutation
    SET_TODOS (todos: Array<ITodoLineItem & { showTooltip?: boolean }>) {
        this.todos = todos
    }

    @Mutation
    SET_PAYMENTS_DATA (paymentsData: ITodoPaymentData) {
        this.paymentsData = paymentsData
    }

    @Action
    async getTodoList (filters: any) {
        const { lineItems, paymentsData } = await Api.todo.getTodoList(filters)
        this.SET_TODOS(lineItems)
        this.SET_PAYMENTS_DATA(paymentsData)
    }
}
